import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { queryClient } from "@/lib/queryClient";

export function invalidateInboxCount() {
  return queryClient.invalidateQueries({ queryKey: ["inbox-count"] });
}

export function useInboxCount(userId: string | undefined) {
  const query = useQuery({
    queryKey: ["inbox-count", userId],
    enabled: !!userId,
    staleTime: 60_000,
    queryFn: async () => {
      const [ownRes, reviewRes] = await Promise.all([
        supabase
          .from("memories")
          .select("id", { count: "exact", head: true })
          .eq("user_id", userId!)
          .eq("status", "pending"),
        supabase
          .from("memories")
          .select("id", { count: "exact", head: true })
          .eq("approval_status", "pending"),
      ]);
      return (ownRes.count ?? 0) + (reviewRes.count ?? 0);
    },
  });

  return {
    data: query.data ?? 0,
    count: query.data ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
